var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.583 14.5833L18.333 18.3333",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.667 9.16666C16.667 5.02452 13.3092 1.66666 9.16699 1.66666C5.02486 1.66666 1.66699 5.02452 1.66699 9.16666C1.66699 13.3088 5.02486 16.6667 9.16699 16.6667C13.3092 16.6667 16.667 13.3088 16.667 9.16666Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassIcon);
export default __webpack_public_path__ + "static/media/magnifying-glass-icon.f1d3ae3122ba975b2f12c1c552e6bd22.svg";
export { ForwardRef as ReactComponent };